import {Component} from '@angular/core';
import {
  CompanySimpleDto,
  DictionaryBaseDto,
  DictionaryBaseService,
  PolicyInquiryPrimeDebtorCompanyDto,
  RelatedObject,
  RouterService,
} from '../../../../bonding_shared';
import {PolicyContractViewService} from '../../../policy/services/policy-contract-view.service';
import {InquirySectionDirective} from './inquiry-section';
import {PolicyInquiryCompanyRole} from '../../../../bonding_shared/model/dictionary-ids';

@Component({
  selector: 'inquiry-prime-debtors-section',
  templateUrl: './inquiry-prime-debtors-section.component.pug',
})
export class InquiryPrimeDebtorsSectionComponent extends InquirySectionDirective {
  constructor(
    protected policyContractViewService: PolicyContractViewService,
    public router: RouterService,
    protected dictionaryBaseService: DictionaryBaseService
  ) {
    super(policyContractViewService);
    this.selectorNameList = [RelatedObject.PRIME_DEBTORS];
    this.initializeSelectorEmitters(true);
  }

  addPrimeDebtors(company: CompanySimpleDto) {
    this.inquiry.primeDebtors.push(<PolicyInquiryPrimeDebtorCompanyDto>{
      role: <DictionaryBaseDto>{id: PolicyInquiryCompanyRole.PRIME_DEBTORS},
      company: company,
      multiplierValue: 1,
    });
  }
}
